import { render } from "./ProdutoBacklog.vue?vue&type=template&id=24c2e94e&scoped=true"
import script from "./ProdutoBacklog.vue?vue&type=script&lang=js"
export * from "./ProdutoBacklog.vue?vue&type=script&lang=js"

import "./ProdutoBacklog.vue?vue&type=style&index=0&id=24c2e94e&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c2e94e"]])

export default __exports__